export default __webpack_public_path__ + "43bb8f5.png";